import { Polygon } from 'geojson'
import turf from 'turf'
import { IPoint, IRestrictZone, IRoute, ITransferRoute, IZoneTransferRoute } from 'utils/interfaces'

export const isStartPointInsideRestrictZone = (
  startPoint: IPoint | null | undefined,
  restrictZones: IRestrictZone[]
): boolean => {
  const coordinates = startPoint?.geometry?.coordinates
  if (!coordinates || coordinates.length < 2 || restrictZones.length === 0) {
    return false
  }
  const point = turf.point([coordinates[0], coordinates[1]])
  for (const zone of restrictZones) {
    if (zone?.geometry?.type !== 'Polygon') {
      continue
    }
    try {
      if (turf.inside(point, zone as any)) {
        return true
      }
    } catch (e) {
      console.warn('Error checking start point in restricted zone:', e)
    }
  }
  return false
}

export const checkRestrictZoneIntersection = (
  restrictZoneGeometry: Polygon,
  cleaningRoutes: IRoute[],
  transferRoutes: IZoneTransferRoute[],
  missionPointRoutes: ITransferRoute[]
): boolean => {
  if (!restrictZoneGeometry) return false

  // Check cleaning routes
  for (const route of cleaningRoutes) {
    if (route?.geometry) {
      try {
        const intersection = turf.intersect(restrictZoneGeometry as any, route.geometry as any)
        if (intersection) {
          return true
        }
      } catch (e) {
        console.warn('Error checking cleaning route intersection:', e)
      }
    }
  }

  // Check transfer routes (between zones)
  for (const route of transferRoutes) {
    if (route?.geometry) {
      try {
        const intersection = turf.intersect(restrictZoneGeometry as any, route.geometry as any)
        if (intersection) {
          return true
        }
      } catch (e) {
        console.warn('Error checking transfer route intersection:', e)
      }
    }
  }

  // Check mission point routes (start/finish transfers)
  for (const route of missionPointRoutes) {
    if (route?.geometry) {
      try {
        const intersection = turf.intersect(restrictZoneGeometry as any, route.geometry as any)
        if (intersection) {
          return true
        }
      } catch (e) {
        console.warn('Error checking mission point route intersection:', e)
      }
    }
  }

  return false
}
